import { CardType, CardTypeSlugs } from '@app/enums/_index';
import { Component, Input, OnInit } from '@angular/core';

import { FlexibleLearning } from '@app/models/_index';
import { FlexibleLearningItemFactory } from '@app/factories/flexible-learning-item.factory';

@Component({
  selector: 'app-flexible-learning-list',
  templateUrl: './flexible-learning-list.component.html',
  styleUrls: ['./flexible-learning-list.component.scss'],
  standalone: false,
})
export class FlexibleLearningListComponent implements OnInit {
  flexibleMethodsLearningList: FlexibleLearning[] = [];
  @Input() subscriptionName: string;
  constructor(private flexibleLearningFactory: FlexibleLearningItemFactory) {}

  /**
   * Create a static list of four flexible methods of learning cards used by the Subscription Detail
   */
  ngOnInit(): void {
    // TODO: Move this into CMS in Beyond 3.1 or Beyond future.
    this.flexibleMethodsLearningList = this.flexibleLearningFactory.getCollectionBySubscription(
      this.subscriptionName
    );
  }

  /**
   * Add Track By Flexible Learning list item to not redraw or
   * re-render list items that have not changed. This improves performance.
   * @param index - Index of subscriptionItem array
   * @param item - Flexible Learning list item
   * @returns enrollment id
   */
  trackByLearningItem(index: number, item: FlexibleLearning): string {
    if (item) {
      return item.name;
    } else {
      return String(index);
    }
  }

  /**
   *  cardTypeSlugs enums based on card types
   */
  public get cardTypeSlugs(): typeof CardTypeSlugs {
    return CardTypeSlugs;
  }

  /**
   *  CardType enums based on card types
   */
  public get cardType(): typeof CardType {
    return CardType;
  }
}
